import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
import './App.css';

// Import components
import LandingPage from './components/LandingPage';
import EnrollmentFlow from './components/EnrollmentFlow';
import AdminDashboard from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfSale from './components/TermsOfSale';
import Support from './components/Support';
import PaymentSuccess from './components/PaymentSuccess';
import StudentLogin from './components/StudentLogin';
import StudentDashboard from './components/StudentDashboard';
import CertificateDemo from './components/CertificateDemo';
import LiveNotifications from './components/LiveNotifications';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PaymentConfirm from './components/PaymentConfirm';
import PaymentReceived from './components/PaymentReceived';
import AuthorServices from './components/AuthorServices';
import BecomeSpecialist from './components/BecomeSpecialist';
import AuthorOrderConfirmation from './components/AuthorOrderConfirmation';
import AuthorDashboard from './components/AuthorDashboard';
import AuthorLogin from './components/AuthorLogin';
import BlogInsights from './components/BlogInsights';
import AboutDeveloper from './components/AboutDeveloper';
import VerifyEmail from './components/VerifyEmail';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [adminToken, setAdminToken] = useState(localStorage.getItem('adminToken'));

  // Set up axios defaults
  useEffect(() => {
    axios.defaults.baseURL = API;
    if (adminToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${adminToken}`;
    }
  }, [adminToken]);

  const handleAdminLogin = (token) => {
    setAdminToken(token);
    localStorage.setItem('adminToken', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  const handleAdminLogout = () => {
    setAdminToken(null);
    localStorage.removeItem('adminToken');
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <HelmetProvider>
      <div className="App">
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/enroll" element={<EnrollmentFlow />} />
            <Route path="/success" element={<PaymentSuccess />} />
            <Route path="/cancel" element={<EnrollmentFlow />} />
            <Route path="/admin/login" element={
              adminToken ? <Navigate to="/admin/dashboard" /> : <AdminLogin onLogin={handleAdminLogin} />
            } />
            <Route path="/admin/dashboard" element={
              adminToken ? <AdminDashboard onLogout={handleAdminLogout} /> : <Navigate to="/admin/login" />
            } />
            <Route path="/student-login" element={<StudentLogin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/student-dashboard" element={<StudentDashboard />} />
            <Route path="/payment-confirm" element={<PaymentConfirm />} />
            <Route path="/payment-received" element={<PaymentReceived />} />
            <Route path="/certificate-demo" element={<CertificateDemo />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfSale />} />
            <Route path="/support" element={<Support />} />
            <Route path="/book-video-reviews-for-authors" element={<AuthorServices />} />
            <Route path="/become-a-video-book-review-specialist" element={<BecomeSpecialist />} />
            <Route path="/author-order-confirmation" element={<AuthorOrderConfirmation />} />
            <Route path="/author-dashboard" element={<AuthorDashboard />} />
            <Route path="/author-login" element={<AuthorLogin />} />
            <Route path="/blog-insights" element={<BlogInsights />} />
            <Route path="/about-developer" element={<AboutDeveloper />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
          </Routes>
          
          {/* Live Notifications - Show on all pages except admin */}
          {!window.location.pathname.includes('/admin') && <LiveNotifications />}
        </Router>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;